// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-message {
  position: relative;
  padding: 0.6rem 0 0.5rem;
  display: flex;
  /* start messages*/
}
.lsn-message .lsn-message-img {
  padding: 0px 14px 0px 16px;
  display: inline-block;
}
.lsn-message .lsn-message-img i {
  font-size: var(--main-font-size-primary);
}
.lsn-message .lsn-message-img i.fa-minus-circle {
  transform: rotate(45deg);
}
.lsn-message .lsn-message-img[hidden] {
  display: none;
}
.lsn-message .lsn-message-text {
  color: var(--main-dark-gray);
}
.lsn-message .lsn-message-text:has(~ .lsn-message-close-icon) {
  margin-right: 2rem;
}
.lsn-message .lsn-message-close-icon {
  position: absolute;
  right: 0px;
  cursor: pointer;
  right: 0.7rem;
  top: 50%;
  transform: translateY(-50%);
}
.lsn-message .lsn-message-close-icon:before {
  color: var(--main-dark-gray);
}
.lsn-message.lsn-error-message,
.lsn-message.lsn-decline-message,
.lsn-message.lsn-purple-message {
  border: var(--main-border-width) solid var(--main-purple);
  background-color: color-mix(in srgb, var(--main-purple) 10%, var(--main-white) 80%);
}
.lsn-message.lsn-save-message,
.lsn-message.lsn-yellow-message {
  border: var(--main-border-width) solid var(--main-yellow);
  background-color: color-mix(in srgb, var(--main-yellow) 10%, var(--main-white) 80%);
}
.lsn-message.lsn-submit-message,
.lsn-message.lsn-green-message {
  border: var(--main-border-width) solid var(--main-dark-green);
  background-color: color-mix(in srgb, var(--main-dark-green) 10%, var(--main-white) 80%);
}
.lsn-message.lsn-red-message {
  border: var(--main-border-width) solid var(--main-dark-red);
  background-color: color-mix(in srgb, var(--main-dark-red) 10%, var(--main-white) 80%);
}
`, "",{"version":3,"sources":["webpack://./src/components/visual/Alert/Alert.less"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,wBAAA;EACA,aAAA;EAAA,kBAAkB;AACpB;AAJA;EAMI,0BAAA;EACA,qBAAA;AACJ;AARA;EAUM,wCAAA;AACN;AAXA;EAcM,wBAAA;AAAN;AAGI;EACE,aAAA;AADN;AAjBA;EAuBI,4BAAA;AAHJ;AAKI;EACE,kBAAA;AAHN;AAvBA;EA+BI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;AALJ;AAOI;EACE,4BAAA;AALN;AAUE;;;EAGE,yDAAA;EACA,mFAAA;AARJ;AAWE;;EAEE,yDAAA;EACA,mFAAA;AATJ;AAYE;;EAEE,6DAAA;EACA,uFAAA;AAVJ;AAaE;EACE,2DAAA;EACA,qFAAA;AAXJ","sourcesContent":["// this must be moved into the standalone component\n.lsn-message {\n  position: relative;\n  padding: .6rem 0 .5rem;\n  display: flex;\n\n  .lsn-message-img {\n    padding: 0px 14px 0px 16px;\n    display: inline-block;\n\n    i {\n      font-size: var(--main-font-size-primary);\n    }\n\n    i.fa-minus-circle {\n      transform: rotate(45deg);\n    }\n\n    &[hidden] {\n      display: none;\n    }\n  }\n\n  .lsn-message-text {\n    color: var(--main-dark-gray);\n\n    &:has(~ .lsn-message-close-icon) {\n      margin-right: 2rem;\n    }\n  }\n\n  .lsn-message-close-icon {\n    position: absolute;\n    right: 0px;\n    cursor: pointer;\n    right: .7rem;\n    top: 50%;\n    transform: translateY(-50%);\n\n    &:before {\n      color: var(--main-dark-gray);\n    }\n  }\n\n  /* start messages*/\n  &.lsn-error-message,\n  &.lsn-decline-message,\n  &.lsn-purple-message {\n    border: var(--main-border-width) solid var(--main-purple);\n    background-color: color-mix(in srgb, var(--main-purple) 10%, var(--main-white) 80%);\n  }\n\n  &.lsn-save-message,\n  &.lsn-yellow-message {\n    border: var(--main-border-width) solid var(--main-yellow);\n    background-color: color-mix(in srgb, var(--main-yellow) 10%, var(--main-white) 80%);\n  }\n\n  &.lsn-submit-message,\n  &.lsn-green-message {\n    border: var(--main-border-width) solid var(--main-dark-green);\n    background-color: color-mix(in srgb, var(--main-dark-green) 10%, var(--main-white) 80%);\n  }\n\n  &.lsn-red-message {\n    border: var(--main-border-width) solid var(--main-dark-red);\n    background-color: color-mix(in srgb, var(--main-dark-red) 10%, var(--main-white) 80%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
